import React, {useCallback} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useSwipeable} from 'react-swipeable';

import {Offcanvas, Container, Button} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

import './ExpertCompanion.scss'

const OffcanvasExpertCompanion = props => {
    const navigate = useNavigate()
    const location = useLocation()

    // --------------------------------------------------------------------------------------------------- show and hide

    const handlePopstate = useCallback(() => {

        if (document.querySelectorAll('.offcanvas').length < 2)
            window.removeEventListener('popstate', handlePopstate)

        props.onHide()

    },[])

    const onShowHandler = () => {

        document.querySelector('#offcanvasExpertCompanion > div').style.paddingRight = document.querySelector('body').style.paddingRight

        navigate(`${location.hash}#offcanvasExpertCompanion`)
        window.addEventListener('popstate',  handlePopstate);

    }

    const onHideHandler = () => {

        navigate(-1)

    }

    const swipe = useSwipeable({
        onSwiping: (data) => {

            if (data.deltaY > 0 && data.deltaY < data.event.target.closest('.offcanvas').offsetHeight)
                data.event.target.closest('.offcanvas').style.transform = `translateY(${data.deltaY}px)`

        },
        onSwiped: (data) => {

            if (data.velocity > .9) {

                data.event.target.closest('.offcanvas').style.transform = `translateY(100%)`
                onHideHandler()

            } else {

                let h = data.event.target.closest('.offcanvas').offsetHeight
                let translateY = getComputedStyle(data.event.target.closest('.offcanvas')).transform.match(/matrix.*\((.+)\)/)[1].split(', ')[5]

                if (translateY > h / 2) {

                    data.event.target.closest('.offcanvas').style.transform = `translateY(100%)`
                    onHideHandler()

                } else data.event.target.closest('.offcanvas').style.transform = ''
            }

        }
    });

    // -----------------------------------------------------------------------------------------------------------------

    // از کلاس fixed-bottom استفاده شد تا padding-right ایجاد گردد
    return (
        <Offcanvas id="offcanvasExpertCompanion" {...props} placement="bottom" onHide={onHideHandler} onShow={onShowHandler} backdropClassName="offcanvas-expert-companion" className="ltr fixed-bottom">
            <div className="w-100vw">
                <Container fluid="lg" className="px-0 rtl">
                    <Offcanvas.Header className="position-sticky top-0 flex-column flex-md-row">
                        <Button variant="link" className="pt-1 pb-3 align-self-stretch d-flex justify-content-center d-md-none minimize" onClick={onHideHandler} onTouchStart={e => e.target.closest('.offcanvas').classList.add('swiping')} onTouchEnd={e => e.target.closest('.offcanvas').classList.remove('swiping')} {...swipe}/>
                        <Offcanvas.Title>{props.data?.title}</Offcanvas.Title>
                        <Button variant="link" className="text-reset border-0 btn-icon d-none d-md-inline-flex" aria-label="Close" onClick={onHideHandler}><IconFi.FiX size={24} className="m-2 sw-1"/></Button>
                    </Offcanvas.Header>
                    <Offcanvas.Body className="py-0 overflow-visible">
                        {
                            props.data?.img && (
                                <figure className="bg-elevate-1 ratio ratio-1x1 mb-4 mx-auto filter-warm">
                                    <span className="filter-level"/><img src={props.data?.img} alt="" className="h-100 w-100 object-fit-cover"/>
                                </figure>
                            )
                        }
                        {props.data?.desc}
                        <div className="position-sticky bottom-0 py-2 pb-md-4 pb-xl-5 d-grid offcanvas-btn">
                            <Button className="my-1">رزرو آنلاین</Button>
                        </div>
                    </Offcanvas.Body>
                </Container>
            </div>
        </Offcanvas>
    )
}

export default OffcanvasExpertCompanion;